/**
 * Räkning av en avvikelsegranskning — spegling av functions/src/utils/auditSummary.ts.
 * Håll dem identiska.
 *
 * Vyn och rapporten räknade "kunde inte kontrolleras" olika (NO_DATA + API_ERROR
 * mot bara NO_DATA). Nu finns definitionen på ett ställe per paket, med samma
 * innehåll, så siffrorna inte kan glida isär igen.
 */

export const UNCHECKED_VERDICTS = ['NO_DATA', 'API_ERROR'];

/** Samma nyckel som backend: en lägenhet, inte en boende. */
export function auditApartmentKey(r) {
  return `${r?.apartmentNumber ?? ''}|||${r?.address ?? ''}`;
}

export function isUncheckedVerdict(verdict) {
  return UNCHECKED_VERDICTS.includes(verdict ?? '');
}

export function summarizeAuditResults(results = []) {
  const uniq = (pred) => new Set(results.filter(pred).map(auditApartmentKey)).size;

  const totalApartments = uniq(() => true);
  const unchecked = uniq((r) => isUncheckedVerdict(r.verdict));
  const avvikelser = uniq((r) => r.verdict === 'AVVIKELSE');
  const totalChecked = totalApartments - unchecked;

  return {
    totalApartments,
    totalChecked,
    godkanda: uniq((r) => r.verdict === 'GODKAND'),
    inneboende: uniq((r) => r.verdict === 'INNEBOENDE'),
    avvikelser,
    unchecked,
    noData: uniq((r) => r.verdict === 'NO_DATA'),
    apiErrorApartments: uniq((r) => r.verdict === 'API_ERROR'),
    avvikelsePercent: totalChecked > 0 ? Math.round((avvikelser / totalChecked) * 1000) / 10 : 0,
  };
}
